import { render } from "./ChatRecom.vue?vue&type=template&id=ea964dbe&scoped=true"
import script from "./ChatRecom.vue?vue&type=script&lang=js"
export * from "./ChatRecom.vue?vue&type=script&lang=js"

import "./ChatRecom.vue?vue&type=style&index=0&id=ea964dbe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea964dbe"]])

export default __exports__